/**
 * Background Mode bridge for Capacitor native app.
 *
 * On native: starts an Android foreground service so uploads survive
 * the app being backgrounded or the screen being locked.
 *
 * On web: all calls are no-ops.
 */

let BackgroundMode = null;

function getPlugin() {
  if (BackgroundMode) return BackgroundMode;
  try {
    // Capacitor injects its bridge when running inside the native shell.
    // registerPlugin creates a JS proxy that calls native methods.
    const { registerPlugin } = require('@capacitor/core');
    BackgroundMode = registerPlugin('BackgroundMode');
  } catch {
    BackgroundMode = null;
  }
  return BackgroundMode;
}

export function isNative() {
  try {
    return window.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

export async function enableBackgroundMode(title, text) {
  if (!isNative()) return;
  try {
    const plugin = getPlugin();
    if (plugin) await plugin.enable({ title, text });
  } catch (e) {
    console.warn('BackgroundMode.enable failed:', e);
  }
}

export async function updateBackgroundProgress(title, text, progress) {
  if (!isNative()) return;
  try {
    const plugin = getPlugin();
    if (plugin) await plugin.updateNotification({ title, text, progress });
  } catch {
    // ignore — notification updates are best-effort
  }
}

export async function disableBackgroundMode(showComplete = false, completeTitle = '', completeText = '') {
  if (!isNative()) return;
  try {
    const plugin = getPlugin();
    if (plugin) await plugin.disable({ showComplete, completeTitle, completeText });
  } catch (e) {
    console.warn('BackgroundMode.disable failed:', e);
  }
}
